const htmlEntities = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

export const stripHtml = value => {
  if (value == null) return '';

  return String(value)
    .replace(/<\/(p|div|h[1-6]|li|ul|ol|br)>/gi, ' ')
    .replace(/<li[^>]*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/&(#(\d+)|#x([a-f0-9]+)|[a-z]+);/gi, (match, entity, decimal, hex) => {
      if (decimal) return String.fromCharCode(parseInt(decimal, 10));
      if (hex) return String.fromCharCode(parseInt(hex, 16));
      return htmlEntities[entity.toLowerCase()] || match;
    })
    .replace(/\s+/g, ' ')
    .trim();
};
